import axios from 'axios'

// 获取日志列表
export function getLogsList(params) {
  // 后端期望参数：pageNum, pageSize, dateStart, dateEnd, operType, excludeUser, queryUser
  return axios.get(process.env.VUE_APP_BASE_API + '/logs/list', { params })
}

// 获取操作类型列表
export function getBusinessTypes(params) {
  return axios.get(process.env.VUE_APP_BASE_API + '/logs/business-types', { params })
}

export default {
  getLogsList,
  getBusinessTypes
}
